export default "__VITE_ASSET__BYiRBC8Q__"